import axios from "axios";
import router from "./router.js";
import store from "./store.js";

export async function redirectBasedOnIsAddedAfterLogginIn(next) {
  await getIsAdded();
  if (localStorage.getItem("is-added") == "true") {
    next("/floors");
  } else {
    next("/how-to-add");
  }
}

export function authorize_with_code(next, code) {
  console.log("Sending an auth request.");
  const payload = { code: code };

  axios
    .post("/api/auth", payload)
    .then(res => {
      localStorage.setItem("logged-in", true);
      console.log(res);
      redirectBasedOnIsAddedAfterLogginIn(next);
    })
    .then(() => {
      axios.get("/api/hello");
    });
}

export function add_to_slack(next, code) {
  console.log("Adding to Slack.");
  const payload = { code: code };

  axios
    .post("/api/add_to_slack", payload)
    .then(res => {
      localStorage.setItem("logged-in", true);
      console.log("res:", res);
      redirectBasedOnIsAddedAfterLogginIn(next);
    })
    .then(() => {
      axios.get("/api/hello");
    });
}

export async function getAllData() {
  await getData();
  await getIsAdded();
  await getUsers();
}

export async function getData() {
  try {
    const res = await axios.get("/api/get_data");
    console.log("/api/get_data result:", res.data);
    store.commit("SET_BUILDINGS", res.data);
  } catch (err) {
    console.log("Error getting data:", err);
    if (err.response.status === 401) {
      // 401 means "Unauthorized".
      router.push("/sign-in-to-slack");
    }
  }
}

// TODO: Replace with data fetched in getUsers.
export async function getIsAdded() {
  try {
    const res = await axios.get("/api/is_added");
    localStorage.setItem("is-added", res.data.is_added);
  } catch (err) {
    // Prevent from asking to add again in case of random request error.
    store.commit("setIsAdded", true);
  }
}

function getInitialDisplayNameToAvatar() {
  return {
    // The old format. The support can be dropped after some time.
    "DavidSmith (Example)":
      "https://storage.googleapis.com/dango-avatars/david.jpeg",
    "HarrisonWalker (Example)":
      "https://storage.googleapis.com/dango-avatars/harrison.jpeg",
    "RaymondHardy (Example)":
      "https://storage.googleapis.com/dango-avatars/raymond.jpeg",
    "EvaSilva (Example)":
      "https://storage.googleapis.com/dango-avatars/eva.jpeg",
    "JuliaDavies (Example)":
      "https://storage.googleapis.com/dango-avatars/julia.jpeg",
    "LauraBaker (Example)":
      "https://storage.googleapis.com/dango-avatars/laura.jpeg",
    "HollieRogers (Example)":
      "https://storage.googleapis.com/dango-avatars/hollie.jpeg",
    "EmmaDonovan (Example)":
      "https://storage.googleapis.com/dango-avatars/emma.jpeg",
    "SamuelBailey (Example)":
      "https://storage.googleapis.com/dango-avatars/samuel.jpeg",
    "DerickCrawford (Example)":
      "https://storage.googleapis.com/dango-avatars/derick.jpeg",
    "ArloMcintyre (Example)":
      "https://storage.googleapis.com/dango-avatars/arlo.jpeg",
    "AmeliaDean (Example)":
      "https://storage.googleapis.com/dango-avatars/amelia.jpeg",
    "MelissaCarter (Example)":
      "https://storage.googleapis.com/dango-avatars/melissa.jpeg",
    "JonathanMcneil (Example)":
      "https://storage.googleapis.com/dango-avatars/jonathan.jpeg",
    "MichealSnider (Example)":
      "https://storage.googleapis.com/dango-avatars/michael.jpeg",
    "MaverickStout (Example)":
      "https://storage.googleapis.com/dango-avatars/maverick.jpeg",
    "CamiloNorman (Example)":
      "https://storage.googleapis.com/dango-avatars/camilo.jpeg",
    "EwanGray (Example)":
      "https://storage.googleapis.com/dango-avatars/ewan.jpeg",
    "AnnalisePope (Example)":
      "https://storage.googleapis.com/dango-avatars/annalise.jpeg",
    "MileyWeaver (Example)":
      "https://storage.googleapis.com/dango-avatars/miley.jpeg",
    "ElleCameron (Example)":
      "https://storage.googleapis.com/dango-avatars/elle.jpeg",
    "JohnCarter (Example)":
      "https://storage.googleapis.com/dango-avatars/john.jpeg",
    "KeithWoodard (Example)":
      "https://storage.googleapis.com/dango-avatars/keith.jpeg",
    "JakeVega (Example)":
      "https://storage.googleapis.com/dango-avatars/jake.jpeg",
    "IsabelRoth (Example)":
      "https://storage.googleapis.com/dango-avatars/isabel.jpeg",
    "MayaBailey (Example)":
      "https://storage.googleapis.com/dango-avatars/maya.jpeg",
    "JuliusHappe (Example)":
      "https://storage.googleapis.com/dango-avatars/julius.jpeg",
    "RaniParekh (Example)":
      "https://storage.googleapis.com/dango-avatars/rani.jpeg",
    "TashiroShuji (Example)":
      "https://storage.googleapis.com/dango-avatars/tashiro.jpeg",
    // The new simplified format.
    "David Smith": "https://storage.googleapis.com/dango-avatars/david.jpeg",
    "Harrison Walker":
      "https://storage.googleapis.com/dango-avatars/harrison.jpeg",
    "Raymond Hardy":
      "https://storage.googleapis.com/dango-avatars/raymond.jpeg",
    "Eva Silva": "https://storage.googleapis.com/dango-avatars/eva.jpeg",
    "Julia Davies": "https://storage.googleapis.com/dango-avatars/julia.jpeg",
    "Laura Baker": "https://storage.googleapis.com/dango-avatars/laura.jpeg",
    "Hollie Rogers": "https://storage.googleapis.com/dango-avatars/hollie.jpeg",
    "Emma Donovan": "https://storage.googleapis.com/dango-avatars/emma.jpeg",
    "Samuel Bailey": "https://storage.googleapis.com/dango-avatars/samuel.jpeg",
    "Derick Crawford":
      "https://storage.googleapis.com/dango-avatars/derick.jpeg",
    "Arlo Mcintyre": "https://storage.googleapis.com/dango-avatars/arlo.jpeg",
    "Amelia Dean": "https://storage.googleapis.com/dango-avatars/amelia.jpeg",
    "Melissa Carter":
      "https://storage.googleapis.com/dango-avatars/melissa.jpeg",
    "Jonathan Mcneil":
      "https://storage.googleapis.com/dango-avatars/jonathan.jpeg",
    "Micheal Snider":
      "https://storage.googleapis.com/dango-avatars/michael.jpeg",
    "Maverick Stout":
      "https://storage.googleapis.com/dango-avatars/maverick.jpeg",
    "Camilo Norman": "https://storage.googleapis.com/dango-avatars/camilo.jpeg",
    "Ewan Gray": "https://storage.googleapis.com/dango-avatars/ewan.jpeg",
    "Annalise Pope":
      "https://storage.googleapis.com/dango-avatars/annalise.jpeg",
    "Miley Weaver": "https://storage.googleapis.com/dango-avatars/miley.jpeg",
    "Elle Cameron": "https://storage.googleapis.com/dango-avatars/elle.jpeg",
    "John Carter": "https://storage.googleapis.com/dango-avatars/john.jpeg",
    "Keith Woodard": "https://storage.googleapis.com/dango-avatars/keith.jpeg",
    "Jake Vega": "https://storage.googleapis.com/dango-avatars/jake.jpeg",
    "Isabel Roth": "https://storage.googleapis.com/dango-avatars/isabel.jpeg",
    "Maya Bailey": "https://storage.googleapis.com/dango-avatars/maya.jpeg",
    "Julius Happe": "https://storage.googleapis.com/dango-avatars/julius.jpeg",
    "Rani Parekh": "https://storage.googleapis.com/dango-avatars/rani.jpeg",
    "Tashiro Shuji": "https://storage.googleapis.com/dango-avatars/tashiro.jpeg"
  };
}

async function initUserToImage(getUsersResponse) {
  var initialUserDisplayNameToAvatar = getInitialDisplayNameToAvatar();
  if (!getUsersResponse.data.users) {
    store.commit("setUserToImage", initialUserDisplayNameToAvatar);
    return;
  }
  var userDisplayNameToAvatar = getUsersResponse.data.users.reduce(function(
    mapping,
    user
  ) {
    mapping[user.display_name] = user.image_72;
    return mapping;
  },
  initialUserDisplayNameToAvatar);
  store.commit("setUserToImage", userDisplayNameToAvatar);
}

async function initUserDisplayNames(getUsersResponse) {
  if (!getUsersResponse.data.users) {
    return;
  }
  var userDisplayNames = getUsersResponse.data.users.reduce(function(
    arr,
    user
  ) {
    arr.push(user.display_name);
    return arr;
  },
  []);
  store.commit("setUserDisplayNames", userDisplayNames);
}

export async function getUsers() {
  try {
    const res = await axios.get("/api/get_users");
    await initUserToImage(res);
    await initUserDisplayNames(res);
  } catch (err) {
    console.log("Error getting users:", err);
  }
}

export async function addBuilding(name) {
  const res = await axios.post("/api/add_building", { name: name });
  console.log("/api/add_building result:", res.data);

  await getData();
}

export async function addFloor(name, building_id, image_base64) {
  const payload = {
    name: name,
    building_id: building_id,
    image_base64: image_base64
  };

  const res = await axios.post("/api/add_floor", payload);
  console.log("/api/add_floor result:", res.data);

  await getData();
}

export async function addLocation(name, x, y, floor_id) {
  const payload = {
    name: name,
    x: x,
    y: y,
    floor_id: floor_id
  };

  store.commit("setStatusBox", "wait_add_location");
  const start = new Date().getTime();
  try {
    const res = await axios.post("/api/add_location", payload);
    console.log("/api/add_location result:", res);
  } catch (error) {
    console.log("error: ", error.response.status);
    store.commit("setStatusBox", "generic_error");
    await getData();
    return;
  }

  await getData();
  const end = new Date().getTime();
  setTimeout(() => {
    store.commit("setStatusBox", "added_location");
  }, 1500 - (end - start));
}

export async function deleteBuilding(buildingId) {
  const res = await axios.post("/api/delete_building", { id: buildingId });
  console.log("/api/delete_building result:", res.data);

  await getData();
}

export async function deleteFloor(floorId) {
  const res = await axios.post("/api/delete_floor", { id: floorId });
  console.log("/api/delete_floor result:", res.data);

  await getData();
}

export async function deleteLocation(locationId) {
  const res = await axios.post("/api/delete_location", { id: locationId });
  console.log("/api/delete_location result:", res.data);

  await getData();
}

export async function setLocationTags(locationId, tags) {
  const payload = {
    id: locationId,
    tags: tags
  };
  console.log(payload);
  const res = await axios.post("/api/set_location_tags", payload);
  console.log("/api/set_location_tags result:", res.data);

  await getData();
}

export async function renameBuilding(buildingId, newName) {
  const payload = {
    id: buildingId,
    new_name: newName
  };

  const res = await axios.post("/api/rename_building", payload);
  console.log("/api/rename_building result:", res.data);

  await getData();
}

export async function renameFloor(floorId, newName) {
  const payload = {
    id: floorId,
    new_name: newName
  };

  const res = await axios.post("/api/rename_floor", payload);
  console.log("/api/rename_floor result:", res.data);

  await getData();
}

export async function sendFeedback(text) {
  console.log("text:", text);
  const payload = {
    text: text
  };

  const res = await axios.post("/api/send_feedback", payload);
  console.log("/api/send_feedback result:", res.data);
}
